import React, { useState, useEffect } from 'react';
import { Form, Button, Row, Col, Card, Container, Table} from 'react-bootstrap';
import Sidebar from './Sidebar';
import ToastConfirmation from './ToastConfirmation';
import {
  getSegregationVariables,
  updateSegregationVariable,
  deleteSegregationVariable,
  addSegregationVariables,
  getSegregationSelections,
  updateSegregationSelection,
  deleteSegregationSelection,
  addSegregationSelections,
} from './apiCalls';

export default function SegregationFeaturesEdit() {

  const [showToaster, setShowToaster] = useState(false);
  const [segregationVariables, setSegregationVariables] = useState([]);
  const [segregationVariablesFormData, setSegregationVariablesFormData] = useState([]);

  const [segregationSelections, setSegregationSelections] = useState([]);
  const [segregationSelectionsFormData, setSegregationSelectionsFormData] = useState([]);

  useEffect(() => {
    getSegregationVariables(setSegregationVariables);
    getSegregationSelections(setSegregationSelections);
  }, []);

  const saveSegregationVariable = (id) => {
    segregationVariablesFormData.hasOwnProperty(id) && updateSegregationVariable(id, segregationVariablesFormData[id]);
    setShowToaster(true);
  }

  const handleDeleteSegregationVariable = (id) => {
    deleteSegregationVariable(id)
    .then(() => setShowToaster(true));
    
    setSegregationVariables([
      ...segregationVariables.filter((item) => {
        return item.id !== id
      })
    ]);

    // filter keys and let every key distinct to id
    setSegregationVariablesFormData(
      Object.keys(segregationVariablesFormData)
        .filter(key => key !== id)
        .reduce((obj, key) => {
          return {
            ...obj,
            [key]: segregationVariablesFormData[key]
          };
        }, {})
    );
  }

  const handleAddSegregationVariable = () => {
    addSegregationVariables([{
      "form_id":"ID",
      "name":"NOMBRE DE VARIABLE",
      "label": "ALIAS DE VARIABLE"
    }])
      .then(getSegregationVariables(setSegregationVariables))
      .then(() => setShowToaster(true));
  }

  const saveSegregationSelection = (id) => {
    segregationSelectionsFormData.hasOwnProperty(id) && updateSegregationSelection(id, segregationSelectionsFormData[id]);
    setShowToaster(true);
  }

  const handleDeleteSegregationSelection = (id) => {
    deleteSegregationSelection(id)
    .then(() => setShowToaster(true));
    
    setSegregationSelections([
      ...segregationSelections.filter((item) => {
        return item.id !== id
      })
    ]);

    // filter keys and let every key distinct to id
    setSegregationSelectionsFormData(
      Object.keys(segregationSelectionsFormData)
        .filter(key => key !== id)
        .reduce((obj, key) => {
          return {
            ...obj,
            [key]: segregationSelectionsFormData[key]
          };
        }, {})
    );
  }

  const handleAddSegregationSelection = () => {
    addSegregationSelections([{
      "form_id":"ID",
      "name":"NOMBRE DE VARIABLE",
      "label": "ALIAS DE VARIABLE"
    }])
      .then(getSegregationSelections(setSegregationSelections))
      .then(() => setShowToaster(true));
  }


  const segregationFormContent = (
    <>
    <p>{/* JSON.stringify(odiseaForm) */}</p>
    <ToastConfirmation showToaster={showToaster} setShowToaster={ setShowToaster } message={ 'Contenido guardado con éxito!' }/>
    <Form>
      <Form.Group className="admin-content-group">
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>#</th>
            <th>Variable</th>
            <th>Label</th>
            <th>Operaciones</th>
          </tr>
        </thead>
        <tbody>
          {
            segregationVariables && segregationVariables.map((item, itemId) => {
              return (
                <tr>
                  <td>{itemId + 1}</td>
                  <td>
                    <Form.Control
                      placeholder="Etiqueta de variable"
                      defaultValue={ item.name }
                      value={ segregationVariablesFormData[item.id]?.name ? segregationVariablesFormData[item.id].name : item.name}
                      onChange={ (e) => {
                        setSegregationVariablesFormData({
                          ...segregationVariablesFormData,
                          [item.id] : {
                            'form_id': e.target.value,
                            'name': e.target.value,
                            'label': segregationVariablesFormData[item.id] ? segregationVariablesFormData[item.id]['label'] : item.label,
                          }
                        });
                      } }  
                    />
                  </td>
                  <td>
                    <Form.Control
                      placeholder="Titulo"
                      defaultValue={ item.label }
                      value={ segregationVariablesFormData[item.id]?.label ? segregationVariablesFormData[item.id].label : item.label}
                      onChange={ (e) => {
                        setSegregationVariablesFormData({
                          ...segregationVariablesFormData,
                          [item.id] : {
                            'form_id': segregationVariablesFormData[item.id] ? segregationVariablesFormData[item.id]['name'] : item.name,
                            'name': segregationVariablesFormData[item.id] ? segregationVariablesFormData[item.id]['name'] : item.name,
                            'label': e.target.value
                          }
                        });
                      } }  
                    />
                  </td>
                  <td><Button _type="submit" className="admin-add-item-button" onClick={() => {saveSegregationVariable(item.id);}}>Guardar</Button> | <Button _type="submit" className="admin-delete-item-button" onClick={() => {handleDeleteSegregationVariable(item.id)}}>Eliminar</Button> </td>
                </tr>
              )
            })
          }
        </tbody>
      </Table>

      <Button _type="submit" className="odisea-form-button-submit" onClick={() => {handleAddSegregationVariable()}}>Agregar Variable</Button>

      </Form.Group>
    </Form>
    </>
  )

  const selectionFormContent = (
    <>
    <p>{/* JSON.stringify(odiseaForm) */}</p>
    <ToastConfirmation showToaster={showToaster} setShowToaster={ setShowToaster } message={ 'Contenido guardado con éxito!' }/>
    <Form>
      <Form.Group className="admin-content-group">
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>#</th>
            <th>Variable</th>
            <th>Label</th>
            <th>Operaciones</th>
          </tr>
        </thead>
        <tbody>
          {
            segregationSelections && segregationSelections.map((item, itemId) => {
              return (
                <tr>
                  <td>{itemId + 1}</td>
                  <td>
                    <Form.Control
                      placeholder="Etiqueta de Selection"
                      defaultValue={ item.name }
                      value={ segregationSelectionsFormData[item.id]?.name ? segregationSelectionsFormData[item.id].name : item.name}
                      onChange={ (e) => {
                        setSegregationSelectionsFormData({
                          ...segregationSelectionsFormData,
                          [item.id] : {
                            'form_id': e.target.value,
                            'name': e.target.value,
                            'label': segregationSelectionsFormData[item.id] ? segregationSelectionsFormData[item.id]['label'] : item.label,
                          }
                        });
                      } }  
                    />
                  </td>
                  <td>
                    <Form.Control
                      placeholder="Titulo"
                      defaultValue={ item.label }
                      value={ segregationSelectionsFormData[item.id]?.label ? segregationSelectionsFormData[item.id].label : item.label}
                      onChange={ (e) => {
                        setSegregationSelectionsFormData({
                          ...segregationSelectionsFormData,
                          [item.id] : {
                            'form_id': segregationSelectionsFormData[item.id] ? segregationSelectionsFormData[item.id]['name'] : item.name,
                            'name': segregationSelectionsFormData[item.id] ? segregationSelectionsFormData[item.id]['name'] : item.name,
                            'label': e.target.value
                          }
                        });
                      } }  
                    />
                  </td>
                  <td><Button _type="submit" className="admin-add-item-button" onClick={() => {saveSegregationSelection(item.id);}}>Guardar</Button> | <Button _type="submit" className="admin-delete-item-button" onClick={() => {handleDeleteSegregationSelection(item.id)}}>Eliminar</Button> </td>
                </tr>
              )
            })
          }
        </tbody>
      </Table>

      <Button _type="submit" className="odisea-form-button-submit" onClick={() => {handleAddSegregationSelection()}}>Agregar Selection</Button>

      </Form.Group>
    </Form>
    </>
  )

  return (
    <Container fluid>
      <Row>
          <Col xs={2} >
            <Sidebar />
          </Col>
          <Col xs={10} className="admin-content">
            <Card>
              <Card.Header>Variables de Segregación</Card.Header>
              <Card.Body>{ segregationFormContent }</Card.Body>
            </Card>
            <Card>
              <Card.Header>Selección geográfica</Card.Header>
              <Card.Body>{ selectionFormContent }</Card.Body>
            </Card>
          </Col> 
      </Row>
    </Container>
  )
}
